import React from 'react';
import icon from 'assets/images/softwares/RodPump1.png';

const Icon = ({ width }) => <img src={icon} alt="RodPump" width={width || '25'} />;

export default Icon;
